module.exports = __webpack_public_path__ + "img/n1.75a4786c.svg";